import React from "react";

const UploadProgress = ({percentComplete}) => {
  return <div className="progress">
    <div className="progress-bar" role="progressbar" style={{width: (percentComplete || 0) + '%', textAlign: 'center'}}>
      {Math.round(percentComplete) || 0}%
    </div>
  </div>
};

export default UploadProgress;
